import axios from 'axios';
// import masterClassesList from './mock-data';

export const getClasses = async () => {
  const res = await axios.get(process.env.REACT_APP_URL, {
    headers: {
      'x-api-key': process.env.REACT_APP_API_KEY,
      accept: 'application/json',
    },
  });
  return res.data;
};

function findDurations(duration) {
  let lowerDuration;
  let upperDuration;
  const upperMargin = 2;
  const upperMarginInSecs = upperMargin * 60;
  switch (parseInt(duration)) {
    case 15:
      lowerDuration = 0;
      upperDuration = 15 * 60 + upperMarginInSecs;
      break;
    case 20:
      lowerDuration = (15 + upperMargin) * 60;
      upperDuration = 20 * 60 + upperMarginInSecs;
      break;
    case 25:
      lowerDuration = (20 + upperMargin) * 60;
      upperDuration = 25 * 60 + upperMarginInSecs;
      break;
    case 30:
      lowerDuration = (25 + upperMargin) * 60;
      upperDuration = 30 * 60 + upperMarginInSecs;
      break;
    case 45:
      lowerDuration = (30 + upperMargin) * 60;
      upperDuration = 45 * 60 + upperMarginInSecs;
      break;
    case 60:
      lowerDuration = (45 + upperMargin) * 60;
      upperDuration = 120 * 60;
      break;
    default:
      // return classes under 15 mins by default
      lowerDuration = 0;
      upperDuration = 15 * 60;
      break;
  }

  return [lowerDuration, upperDuration];
}

export function getFilteredClasses(classes, duration, mood) {
  const [lowerDuration, upperDuration] = findDurations(duration);

  const filteredClasses = classes.filter(function filterClass(c) {
    // eslint-disable-next-line eqeqeq
    const matchesDuration =
      c.duration <= upperDuration && c.duration >= lowerDuration;
    // find if mood matches
    // eslint-disable-next-line eqeqeq
    const matchesMood = c.categories.indexOf(`cp ${mood}`) != -1;
    return matchesDuration && matchesMood;
  });

  return filteredClasses;
}
